<template>
    <div class="main_body">
        <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
        <div class="container-fluid">
            <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
                <div style="margin-left:20px;" class="pb-4">
                    <h3>Play Count From Web</h3>
                </div>
            </div>
            <div>
                <form @submit.prevent="processForm">
                    <h3 class="py-3">Select Dates</h3>
                    <div>
                        <div>
                            <label for="Start Date"><b>Start Date</b> </label>
                            <input class="mx-3 dateStyle" type="date" required v-model="startDate">
                            <label for="End Date"><b>End Date</b> </label>
                            <input class=" mx-3 dateStyle" type="date" required v-model="endDate">
                        </div>

                    </div>
                    <br><br>
                    <button class="btn btn-success">Submit</button><br><br>
                </form>

            </div><br><br>
            <div style="overflow-x:auto">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">AudioBook ID</th>
                            <th scope="col">AudioBook Name</th>
                            <th scope="col">Total played</th>
                            <th scope="col">From channel</th>
                            <!-- <th scope="col">Time</th> -->
                        </tr>
                    </thead>
                    <tbody v-if="dateFlag == true">
                        <tr v-for="(data, index) in dateCounts" :key="index">
                            <td>{{ data.id }}</td>
                            <td>{{ data.audiobook_id }}</td>
                            <td>{{ data.audiobook_name }}</td>
                            <td>{{ data.total_played }}</td>
                            <td>{{ data.from_channel }}</td>
                            <!-- <td class="px-0 d-flex" style="">{{ data.created_at | formatDate }}</td> -->
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr v-for="(data, index) in counts" :key="index">
                            <td>{{ data.id }}</td>
                            <td>{{ data.audiobook_id }}</td>
                            <td>{{ data.audiobook_name }}</td>
                            <td>{{ data.total_played }}</td>
                            <td>{{ data.from_channel }}</td>
                            <!-- <td class="px-0 d-flex" style="">{{ data.created_at | formatDate }}</td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
    data() {
        return {
            signupList: "",
            isLoading: false,
            fullPage: true,
            loader: "bars",
            counts: "",
            dateCounts: "",
            days: null,
            flags: false,
            dateFlag: false,
            startDate: "",
            endDate: ""
        }
    },

    components: {
        Loading
    },
    created() {
        this.list()
    },
    methods: {
        processForm() {
            if (this.checkForm) {
                this.dateFlag = true
                this.listDateWise()
            }
        },
        checkForm() {
            if (this.startDate||this.endDate ) {
                return true
            }
            this.errors = [];
            if (!this.startDate||!this.endDate) {
                this.errors.push("Date required")
                return false
            }
        },
        async list() {
            const token = localStorage.getItem(this.$tokenKey);
            try {
                this.isLoading = true
                const res = await axios.get(
                    this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/audiobook-play-count-total-from-web", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                }
                );
                if (res.status == 200) {
                    // console.log(res)
                    this.counts = res.data
                    this.isLoading = false
                    this.dateFlag=false
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        async listDateWise() {
            const token = localStorage.getItem(this.$tokenKey);
            try {
                this.isLoading = true
                this.startDate = this.startDate.replaceAll('-', '')
                this.endDate = this.endDate.replaceAll('-', '')
                const res = await axios.get(
                    this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/audiobook-play-count-total-from-web?startDate="+this.startDate+"&endDate="+this.endDate, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                }
                );
                if (res.status == 200) {
                    // console.log(res)
                    this.dateCounts = res.data
                    this.isLoading = false
                    this.dateFlag=true
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
    }
}
</script>
<style scoped>
table {
    /* table-layout: fixed; */
    border-collapse: collapse;
    width: 100%;
}

td {
    overflow-x: auto;
}
</style>